import { Component, OnInit, ViewChild, ElementRef, ɵSafeResourceUrl, Renderer2 } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppConfigService } from '../../../shared/appconfig/appconfig.service'
import { environment } from '../../../../environments/environment';
import {
  CloudRadialChatChatwidgetComponent
} from '@cloudradial-dev/crchat-chatwidget';
import { ChatExtensionService } from '@cloudradial-dev/crchat-chatwidget';
import { Observable, of, delay } from 'rxjs';

@Component({
    selector: 'app-bot-botapp',
    templateUrl: './botapp.component.html',
  styleUrls: ['./botapp.component.scss']
})
export class BotAppComponent implements OnInit {
  public channel: string;
  public dev: boolean;
  public safeUrl: SafeResourceUrl;
  public optionsList: string;
  public isEmbedded: boolean = false;
  public widgetMode: string = 'widget';
  public chatExtension: ChatExtensionService;

  protected headers: HttpHeaders;
  @ViewChild('chatboxParent', { static: false }) chatboxParent: ElementRef;
  @ViewChild(CloudRadialChatChatwidgetComponent) chatbox: CloudRadialChatChatwidgetComponent;
  constructor(
    private http: HttpClient,
    private renderer: Renderer2,
    private actRoute: ActivatedRoute,
    private sanitizer: DomSanitizer) {

    this.dev = (environment.chatboxenv === 'dev');
    //this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://chatstyle.ai/');

    console.log('botapp');

    let env = "";
    let auth = "";
    let email = this.actRoute.snapshot.queryParamMap.get('contact_email');
    let embeddedParam = this.actRoute.snapshot.queryParamMap.get('embedded');

    // Check if embedded mode is requested
    this.isEmbedded = embeddedParam === 'true' || embeddedParam === '1';
    this.widgetMode = this.isEmbedded ? 'embedded' : 'widget';
    
    // Check if extension is requested
    let extensionParam = this.actRoute.snapshot.queryParamMap.get('extension');
    let useExtension = extensionParam === 'true' || extensionParam === '1';

    let options:any = {};
    options.isOpen = "true";
    options.isPopup = this.isEmbedded ? "false" : "true";
    options.isApp = "true";
    options.allowScreenshot = "true";
    options.autoStart = "true";
    options.createNew = "true";

    if (email) {
      options.authRequired = "true";
      auth = "\"authRequired\": \"true\", ";
    }
    if (environment.chatboxenv) {
      options.env = environment.chatboxenv;
    }
    this.optionsList = JSON.stringify(options);
    console.log(this.optionsList);

    // Create the test chat extension only if requested
    if (useExtension) {
      this.chatExtension = {
        // beforeMessageSend - modifies the message before it's sent
        beforeMessageSend: (message) => {
          console.log('BotApp Extension: Intercepting message before send:', message);
          
          // Example modifications (commented out to avoid modifying messages):
          // 1. Add a prefix to the message text
          // message.text = '[BotApp Modified] ' + message.text;
          
          // 2. Add custom data
          // if (!message.data) {
          //   message.data = JSON.stringify({
          //     timestamp: new Date().toISOString(),
          //     userAgent: navigator.userAgent,
          //     customField: 'BotApp Extension was here!',
          //     page: 'botapp'
          //   });
          // }
          
          // 3. Add a custom payload to trigger extension search for testing
          // Set the payload to trigger extension search on every message for demo purposes
          //message.payload = 'extension.search';
          
          // IMPORTANT: Must return the message (unmodified now)
          return message;
        },

      // onMessageSent callback
      onMessageSent: (message) => {
        console.log('BotApp Extension: Message was sent:', message);
      },

      // onMessageReceived callback
      onMessageReceived: (message) => {
        console.log('BotApp Extension: Message received:', message);
      },

      // Example search implementation (returns an Observable)
      search: (query) => {
        console.log('BotApp Extension: Searching for:', query);
        
        // Add 3-second delay for all searches to demonstrate loading feature
        console.log('BotApp Extension: Simulating 3-second search delay...');
        return of([
          `BotApp Result 1 for "${query}" (after 3s delay)`, 
          `BotApp Result 2 for "${query}" (after 3s delay)`, 
          `BotApp Result 3 for "${query}" (after 3s delay)`
        ]).pipe(delay(3000));
      },

      // Example navigate implementation
      navigate: (url) => {
        console.log('BotApp Extension: Custom navigation to:', url);
        // Could use custom routing logic here instead of window.open
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    };
    } else {
      this.chatExtension = undefined;
    }

    this.channel = this.actRoute.snapshot.params.id;
    //"{ \"isOpen\": \"true\", \"isPopup\": \"true\", \"isApp\": \"true\", \"allowScreenshot\": \"true\", " + auth + "\"loadHistory\": \"true\", \"autoStart\": \"true\" " + env + " }";
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    let email = this.actRoute.snapshot.queryParamMap.get('contact_email');
    
    if (email) {
      console.log('email=' + email);
      //let chatbox:any = document.querySelector('#chatbox');
      let userInfo: any = {};
      userInfo.email = email;
      userInfo.displayName = email;

      //console.log(chatbox);
      console.log(userInfo);
      this.chatbox.userInfo = userInfo;
    }


    //this.chatbox.init(this.renderer, this.chatboxParent, this.channel);

    //const s = this.renderer.createElement('script');
    //s.type = 'text/javascript';
    //s.src = 'https://cdn.chatstyle.ai/chatbox/chatstyleai.js';
    //s.text = '';
    //if (s.readyState) {
    //  s.onreadystatechange = () => {
    //    if (s.readyState === "loaded" || s.readyState === "complete") {
    //      s.onreadystatechange = null;
    //      console.log('chatbox ready 1');
    //      this.loadChatbox();
    //    }
    //  };
    //} else {
    //  s.onload = () => {
    //    console.log('chatbox ready 2');
    //    this.loadChatbox();
    //  };
    //}

    //this.renderer.appendChild(this.chatboxParent.nativeElement, s);


  }

  //loadChatbox() {
  //  const chatbox = this.renderer.createElement('chatstyleai-chatbox');
  //  this.renderer.setAttribute(chatbox, 'id', 'chatbox');
  //  this.renderer.setAttribute(chatbox, 'channel', this.channel);
  //  this.renderer.setAttribute(chatbox, 'version', '');
  //  this.renderer.setAttribute(chatbox, 'options', '{ "isOpen": "false", "loadHistory": "true", "autoStart":"true", "createNew": "true" }');

  //  // TODO - Consider version in debugging?

  //  this.renderer.appendChild(this.chatboxParent.nativeElement, chatbox);

  //}


}
